import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { environment } from '../../../environments/environment';

type PersonalizacionKey = string;

@Component({
  selector: 'app-v2paquetes',
  templateUrl: './v2paquetes.component.html',
  styleUrls: ['./v2paquetes.component.scss']
})
export class V2paquetesComponent implements OnInit {

  /** Paso activo del funnel visual */
  public status = 1;
  /** Familias v2 habilitadas para el grupo del cliente */
  public familias: any[] = [];
  public selectedFamilia: any = null;
  /** Catalogo de paquetes v2 que viene de la familia seleccionada */
  public paquetes: any[] = [];
  /** Informacion del paquete seleccionado para mostrar en el modal */
  public paqueteDetalle: any[] = [];
  public selectedPaqueteInfo: any = null;
  /** Nombre del paquete que estamos mostrando en el modal */
  public selectedPaqueteNombre = '';
  /** Identificador del cliente autenticado */
  public clienteId: number | null = null;
  /** Avances reportados por /api/getDataUsuario/ */
  public avances: any;
  /** Resumen de seleccion que retorna /api/getPaqueteCliente/ */
  public paquetesSeleccionados: any[] = [];
  public moldurasSeleccionadas: any[] = [];
  public placasSeleccionadas: any[] = [];
  public coloresSeleccionados: any[] = [];
  public dedicatoriasSeleccionadas: any[] = [];
  public totalResumen = 0;

  /** Catalogos de personalizacion v2 filtrados por productos seleccionados */
  public personalizacionCategorias: any[] = [];
  public personalizacionSeleccionada: any[] = [];

  /** Formulario usado para enviar dedicatorias hacia /api/agregarDedicatoriaClienteV2/ */
  public dedicatoriaForm: FormGroup;
  /** Configuracion de botones de personalizacion */
  public personalizacionViews: any[] = [];
  public statusView: number | null = null;
  public selectedOptionId: number | null = null;
  public selectedOptionInput = '';
  private readonly defaultPreviewImage = '../../../assets/img/auri_logo.png';
  public currentPreviewImage = this.defaultPreviewImage;
  public activePreviewIndex = 0;
  private selectedIdsByView: Record<PersonalizacionKey, number | null> = {};
  private selectedNamesByView: Record<PersonalizacionKey, string | null> = {};
  public tokenActual: string | null = null;

  public isLoadingDetalle = false;
  public loadingFamilias = false;
  public loadingPaquetesFamilia = false;
  public loadingResumen = false;
  public loadingPersonalizacion = false;
  public readonly environmentBase = environment.BASE_URL;

  constructor(
    private modalService: NgbModal,
    private paquetesService: PaquetesService,
    private clientesService: ClientesService,
    private fb: FormBuilder,
    private iziToast: Ng2IzitoastService,
    private router: Router
  ) {
    /** Configuramos el formulario de dedicatorias apenas se crea el componente */
    this.dedicatoriaForm = this.fb.group({
      nombre: ['', Validators.required],
      dirigido: ['', Validators.required],
      texto: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    /** En caso de no tener sesion redirigimos al inicio */
    if (!localStorage.getItem('token')) {
      this.router.navigate(['/cliente/inicio']);
      return;
    }
    this.tokenActual = localStorage.getItem('token');
    this.loadClienteData();
    this.loadFamiliasCliente();

  }

  /** Obtiene los datos del cliente autenticado junto con su avance en el funnel */
  private loadClienteData(): void {
    this.clientesService.getDataUsuario().subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.clienteId = response.content.id;
          this.avances = response.avances;
          this.updateStatusFromAvance();
          this.loadResumen();
          this.loadPersonalizacionV2();
          if (this.avances.paquete!==0) {
            this.status = 3;
            if (this.avances.marco!==0 &&
                this.avances.color!==0 &&
                this.avances.placa!==0 &&
                this.avances.dedicatoria!==0) {
              this.status = 4;
            }
          }
        }
      },
      error: (error) => console.error('No se pudo cargar al cliente autenticado', error)
    });
  }

  /** Consulta del backend la seleccion actual del cliente */
  private loadResumen(): void {
    if (!this.clienteId) {
      return;
    }
    this.loadingResumen = true;
    this.clientesService.getPaqueteCliente({ cliente: this.clienteId }).subscribe({
      next: (response:any) => {
        this.loadingResumen = false;
        if (response?.success) {
          this.paquetesSeleccionados = response.content.paquetes || [];
          this.moldurasSeleccionadas = response.content.molduras || [];
          this.placasSeleccionadas = response.content.placas || [];
          this.coloresSeleccionados = response.content.colores || [];
          this.dedicatoriasSeleccionadas = response.content.dedicatorias || [];
          this.totalResumen = response.content.total || 0;
          this.updateSelectionsFromResumen();
        }
      },
      error: (error) => {
        this.loadingResumen = false;
        console.error('No se pudo obtener el resumen del cliente', error);
      }
    });
  }

  /** Solicita del backend las opciones v2 disponibles para los productos seleccionados */
  private loadCatalogosPersonalizacion(): void {
    this.loadPersonalizacionV2();
  }

  private loadPersonalizacionV2(): void {
    if (!this.clienteId) {
      return;
    }
    this.loadingPersonalizacion = true;
    this.clientesService.getPersonalizacionClienteV2().subscribe({
      next: (response:any) => {
        this.loadingPersonalizacion = false;
        if (response?.success) {
          this.personalizacionCategorias = response.content || [];
          this.personalizacionSeleccionada = response.seleccionadas || [];
          this.personalizacionViews = this.personalizacionCategorias.map((categoria) => ({
            id: this.getCategoryId(categoria),
            label: categoria.label || categoria.nombre || 'Personalizacion'
          }));
          this.syncSelectionsFromPersonalizacion();
          if (!this.personalizacionViews.length) {
            this.statusView = null;
            this.selectedOptionId = null;
            this.selectedOptionInput = '';
            this.currentPreviewImage = this.defaultPreviewImage;
            this.activePreviewIndex = 0;
            if (this.avances?.paquete !== 0) {
              this.status = 4;
            }
            return;
          }
          if (!this.statusView || !this.personalizacionViews.some((view) => Number(view.id) === Number(this.statusView))) {
            this.statusView = this.personalizacionViews[0].id;
          }
          this.syncStateWithView();
          if (this.avances?.paquete !== 0 && !this.allPersonalizacionSelected()) {
            this.status = 3;
          }
        }
      },
      error: (error) => {
        this.loadingPersonalizacion = false;
        console.error('No se pudo cargar la personalizacion v2', error);
      }
    });
  }

  /** Obtiene familias v2 disponibles para el grupo del cliente */
  private loadFamiliasCliente(): void {
    this.loadingFamilias = true;
    this.paquetesService.getFamiliasClienteV2().subscribe({
      next: (response:any) => {
        this.loadingFamilias = false;
        if (response?.success) {
          this.familias = response.content || [];
          if (this.familias.length === 1) {
            this.seleccionarFamilia(this.familias[0]);
          }
        }
      },
      error: (error) => {
        this.loadingFamilias = false;
        console.error('No se pudieron cargar las familias', error);
      }
    });
  }

  public seleccionarFamilia(familia: any): void {
    this.selectedFamilia = familia;
    this.paquetes = [];
    this.loadingPaquetesFamilia = true;
    this.paquetesService.getPaquetesFamiliaClienteV2(familia.id).subscribe({
      next: (response:any) => {
        this.loadingPaquetesFamilia = false;
        if (response?.success) {
          this.paquetes = response.content || [];
        } else {
          this.toastSeleccion(response?.error || 'No se pudieron cargar los productos de esta familia.');
        }
      },
      error: (error) => {
        this.loadingPaquetesFamilia = false;
        console.error('No se pudieron cargar los productos de la familia', error);
      }
    });
  }

  public limpiarFamilia(): void {
    this.selectedFamilia = null;
    this.paquetes = [];
  }

  /** Ajusta el paso visual segun los flags del modelo AvanceCliente */
  private updateStatusFromAvance(): void {
    if (!this.avances) {
      this.status = 1;
      return;
    }

    if (this.avances.paquete === 0) {
      this.status = 1;
    } else if (this.avances.marco === 0 || this.avances.color === 0 || this.avances.placa === 0) {
      this.status = 2;
    } else if (this.avances.dedicatoria === 0) {
      this.status = 3;
    } else {
      this.status = 4;
    }
  }

  /** Abre el modal con el detalle del paquete seleccionado */
  public showPaqueteDetalle(paqueteId: number, modal: any): void {
    const paquete = this.paquetes.find((item) => item.id === paqueteId);
    if (!paquete) {
      return;
    }
    this.selectedPaqueteInfo = paquete;
    this.paqueteDetalle = paquete.productos || [];
    this.selectedPaqueteNombre = paquete.nombre || '';
    this.openModal(modal);
  }

  /** Envia la seleccion del paquete v2 y guarda la relacion v2 del cliente */
  public seleccionarPaquete(paqueteId: number): void {
    if (!this.clienteId) {
      return;
    }
    const payload = { paquete_v2: paqueteId, cliente: this.clienteId };
    this.clientesService.agregarPaqueteClienteCatalogoV2(payload).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.iziToast.show({
            title: 'Paquete agregado correctamente',
            titleColor: '#f8f8ff',
            color: '#4CAF50',
            position: 'topRight',
            closeOnEscape: true
          });
          this.loadClienteData();
        } else {
          this.iziToast.show({
            title: response?.error || 'No se pudo seleccionar el paquete',
            titleColor: '#ffffff',
            color: '#CA0B00',
            position: 'topRight',
            closeOnEscape: true
          });
        }
      },
      error: (error) => console.error('No se pudo agregar el paquete', error)
    });
  }

  /** Seleccion de moldura usando /api/agregarMolduraUsuarioV2/ */
  public seleccionarMoldura(molduraId: number | string): void {
    const id = this.toNumericId(molduraId);
    if (!this.clienteId || id == null) {
      return;
    }
    this.marcarOpcionSeleccionada('molduras', id);
    this.clientesService.agregarMolduraUsuarioV2({ moldura: id, usuario: this.clienteId }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion();
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo agregar la moldura', error)
    });
  }

  /** Seleccion de placa usando /api/agregarPlacaUsuarioV2/ */
  public seleccionarPlaca(placaId: number | string): void {
    const id = this.toNumericId(placaId);
    if (!this.clienteId || id == null) {
      return;
    }
    this.marcarOpcionSeleccionada('placas', id);
    this.clientesService.agregarPlacaUsuarioV2({ placa: id, usuario: this.clienteId }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion();
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo agregar la placa', error)
    });
  }

  /** Seleccion de color usando /api/agregarColorUsuarioV2/ */
  public seleccionarColor(colorId: number | string): void {
    const id = this.toNumericId(colorId);
    if (!this.clienteId || id == null) {
      return;
    }
    this.marcarOpcionSeleccionada('colores', id);
    this.clientesService.agregarColorUsuarioV2({ color: id, cliente: this.clienteId }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion();
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo agregar el color', error)
    });
  }

  public eliminarMolduraSeleccion(molduraId: number | string): void {
    const id = this.toNumericId(molduraId);
    if (id == null) {
      return;
    }
    this.clientesService.eliminarMoldura({ moldura: id }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion('Se eliminó la moldura.');
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo eliminar la moldura', error)
    });
  }

  public eliminarPlacaSeleccion(placaId: number | string): void {
    const id = this.toNumericId(placaId);
    if (id == null) {
      return;
    }
    this.clientesService.eliminarPlaca({ placa: id }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion('Se eliminó la placa.');
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo eliminar la placa', error)
    });
  }

  public eliminarColorSeleccion(colorId: number | string): void {
    const id = this.toNumericId(colorId);
    if (id == null) {
      return;
    }
    this.clientesService.eliminarColorUsuario({ color: id }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion('Se eliminó el color.');
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo eliminar el color', error)
    });
  }

  public eliminarDedicatoriaSeleccion(dedicatoriaId: number | string): void {
    const id = this.toNumericId(dedicatoriaId);
    if (id == null) {
      return;
    }
    this.clientesService.eliminarDedicatoriaCliente({ dedicatoria: id }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion('Se eliminó la dedicatoria.');
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo eliminar la dedicatoria', error)
    });
  }

  /** Envia la dedicatoria si el backend no tiene aun el registro */
  public enviarDedicatoria(): void {
    if (!this.clienteId) {
      return;
    }
    this.dedicatoriaForm.markAllAsTouched();
    if (this.dedicatoriaForm.invalid) {
      return;
    }

    const payload = {
      ...this.dedicatoriaForm.value,
      cliente: this.clienteId
    };

    this.clientesService.agregarDedicatoriaClienteV2(payload).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion('Se guardo tu dedicatoria.');
          this.dedicatoriaForm.reset();
          this.loadClienteData();
          this.status=4
        }
      },
      error: (error) => console.error('No se pudo agregar la dedicatoria', error)
    });
  }

  /** Marca las selecciones como completas sin agregar dedicatoria */
  public omitirDedicatoria(): void {
    this.clientesService.omitirDedicatoria({ cliente: this.clienteId }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion('Se omitio la dedicatoria.');
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo omitir la dedicatoria', error)
    });
  }

  /** A falta de un endpoint V2 dedicado, reutilizamos /api/solicitarPaqueteRegistrarme/ */
  public solicitarPedido(): void {
    if (!this.clienteId) {
      return;
    }
    this.clientesService.solicitarPaqueteRegistrarme({ usuario: this.clienteId }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.iziToast.show({
            title: 'Tu solicitud fue enviada, pronto nos pondremos en contacto.',
            titleColor: '#f8f8ff',
            color: '#4CAF50',
            position: 'topRight',
            closeOnEscape: true
          });
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo solicitar el pedido', error)
    });
  }

  /** Utilidad para mostrar un toast reutilizable */
  private toastSeleccion(message: string = 'Se guardo tu seleccion.'): void {
    this.iziToast.show({
      title: message,
      titleColor: '#f8f8ff',
      color: '#4CAF50',
      position: 'topRight',
      closeOnEscape: true
    });
  }

  /** Permite al usuario navegar entre pasos, solo avanzamos si el backend reporta progreso */
  public goToStep(step: number): void {
    //if (step <= this.status) {
      this.status = step;
    //}
  }

  openModal(modal: any): void {
    this.modalService.open(modal, { size: 'xl' });
  }

  dismissAll(): void {
    this.modalService.dismissAll();
  }

  public redirigirAPagos(): void {
    // if (!this.tokenActual) {
    //   this.toastSeleccion('No encontramos tu sesión para procesar el pago.');
    //   return;
    // }

    if (!this.tokenActual) {
      this.toastSeleccion('No encontramos tu sesion para procesar el pago.');
      return;
    }
    this.router.navigate(['/cliente/realizar-pago']);
  }

  public eliminarConfiguracionSeleccion(seleccionId: number | string): void {
    const id = this.toNumericId(seleccionId);
    if (id == null) {
      return;
    }
    this.clientesService.eliminarConfiguracionClienteV2({ seleccion: id }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion('Se elimino la seleccion.');
          this.loadClienteData();
        }
      },
      error: (error) => console.error('No se pudo eliminar la configuracion', error)
    });
  }

  public selectView(status: number): void {
    this.statusView = status;
    this.syncStateWithView();
  }

  public onOptionChange(optionId: number | string): void {
    const parsedId = this.toNumericId(optionId);
    const key = this.getKeyFromView(this.statusView);
    this.selectedIdsByView[key] = parsedId;
    this.selectedOptionId = parsedId;
    const selected = this.findCatalogItemById(parsedId, this.statusView);
    this.selectedOptionInput = selected ? this.getOptionInputLabel(selected) : '';
    this.updatePreviewImage(parsedId);
  }

  public onOptionInputChange(value: string): void {
    this.selectedOptionInput = value;
    const parsedId = this.getOptionIdFromInput(value);
    if (parsedId == null) {
      return;
    }
    const key = this.getKeyFromView(this.statusView);
    this.selectedIdsByView[key] = parsedId;
    this.selectedOptionId = parsedId;
    this.updatePreviewImage(parsedId);
  }

  public guardarOpcion(): void {
    if (this.selectedOptionId == null) {
      return;
    }
    this.clientesService.seleccionarConfiguracionClienteV2({
      configuracion: this.selectedOptionId,
      cliente: this.clienteId
    }).subscribe({
      next: (response:any) => {
        if (response?.success) {
          this.toastSeleccion();
          this.loadClienteData();
        } else {
          this.toastSeleccion(response?.error || 'No se pudo guardar tu seleccion.');
        }
      },
      error: (error) => console.error('No se pudo guardar la configuracion', error)
    });
  }

  private getKeyFromView(view: number | null): PersonalizacionKey {
    return String(view || '');
  }

  private getCatalogByView(view: number | null): any[] {
    const categoria = this.personalizacionCategorias.find((item) => Number(this.getCategoryId(item)) === Number(view));
    return categoria?.opciones || [];
  }

  public get currentCatalog(): any[] {
    return this.getCatalogByView(this.statusView);
  }

  public get currentCategory(): any {
    return this.personalizacionCategorias.find((item) => Number(this.getCategoryId(item)) === Number(this.statusView)) || null;
  }

  public get selectedOptionName(): string {
    const selectedItem = this.findCatalogItemById(this.selectedOptionId, this.statusView);
    const key = this.getKeyFromView(this.statusView);
    return selectedItem?.configuracion || selectedItem?.nombre || this.selectedNamesByView[key] || '';
  }

  public get selectedOptionDescription(): string {
    const selectedItem = this.findCatalogItemById(this.selectedOptionId, this.statusView);
    return selectedItem?.descripcion || '';
  }

  private getCatalogByKey(key: PersonalizacionKey): any[] {
    const categoria = this.personalizacionCategorias.find((item) => String(this.getCategoryId(item)) === String(key));
    return categoria?.opciones || [];
  }

  private ensureDefaultSelection(key: PersonalizacionKey): void {
    const catalog = this.getCatalogByKey(key);
    if (!catalog?.length) {
      if (this.getKeyFromView(this.statusView) === key) {
        this.selectedOptionId = null;
        this.currentPreviewImage = this.defaultPreviewImage;
      }
      return;
    }

    if (this.selectedIdsByView[key] == null) {
      const savedByName = this.findCatalogItemByName(this.selectedNamesByView[key], key);
      this.selectedIdsByView[key] = this.getItemId(savedByName) || this.getItemId(catalog[0]);
    }

    if (this.getKeyFromView(this.statusView) === key) {
      this.selectedOptionId = this.selectedIdsByView[key];
      this.updatePreviewImage(this.selectedOptionId);
      const selected = this.findCatalogItemById(this.selectedOptionId, this.statusView);
      this.selectedOptionInput = selected ? this.getOptionInputLabel(selected) : '';
    }
  }

  private updatePreviewImage(optionId: number | null, view: number = this.statusView): void {
    const catalog = this.getCatalogByView(view);
    const selectedItem = optionId != null
      ? catalog.find(item => this.getItemId(item) === optionId)
      : null;
    const itemForPreview = selectedItem || catalog[0];
    if (view === this.statusView) {
      this.currentPreviewImage = this.buildImagePath(itemForPreview?.imagen);
      this.activePreviewIndex = 0;
    }
  }

  public get currentPreviewImages(): any[] {
    const selectedItem = this.findCatalogItemById(this.selectedOptionId, this.statusView) || this.currentCatalog[0];
    return this.getOptionImages(selectedItem);
  }

  public getOptionImages(option: any): any[] {
    if (!option) {
      return [];
    }
    const images: any[] = [];
    if (option.imagen) {
      images.push({
        id: `main-${option.id}`,
        titulo: option.configuracion || option.nombre || '',
        imagen: option.imagen
      });
    }
    (option.imagenes || []).forEach((imagen) => {
      if (imagen?.imagen) {
        images.push(imagen);
      }
    });
    return images;
  }

  public setPreviewImage(index: number): void {
    const images = this.currentPreviewImages;
    if (!images.length) {
      this.activePreviewIndex = 0;
      this.currentPreviewImage = this.defaultPreviewImage;
      return;
    }
    const nextIndex = (index + images.length) % images.length;
    this.activePreviewIndex = nextIndex;
    this.currentPreviewImage = this.buildImagePath(images[nextIndex]?.imagen);
  }

  public previousPreviewImage(): void {
    this.setPreviewImage(this.activePreviewIndex - 1);
  }

  public nextPreviewImage(): void {
    this.setPreviewImage(this.activePreviewIndex + 1);
  }

  public getOptionValue(option: any): number | null {
    return this.getItemId(option);
  }

  public getOptionInputLabel(option: any): string {
    return option?.configuracion || option?.nombre || '';
  }

  public buildImagePath(imagen?: string): string {
    if (!imagen) {
      return this.defaultPreviewImage;
    }
    if (imagen.startsWith('http')) {
      return imagen;
    }
    return `${this.environmentBase}${imagen}`;
  }

  public getProductoPreviewImage(item: any): string {
    const galeria = item?.imagenes || [];
    const activa = galeria.find((img) => img.activo !== 0);
    return this.buildImagePath(item?.imagen || activa?.imagen);
  }

  public getProductoGaleria(item: any): any[] {
    return (item?.imagenes || []).filter((img) => img.activo !== 0);
  }

  public getProductoVariaciones(item: any): any[] {
    return (item?.variaciones || []).filter((variacion) => variacion.activo !== 0);
  }

  public getConfiguracionesVariacion(variacion: any): any[] {
    return (variacion?.configuraciones || []).filter((config) => config.activo !== 0);
  }

  private syncStateWithView(): void {
    const key = this.getKeyFromView(this.statusView);
    this.ensureDefaultSelection(key);
  }

  private updateSelectionsFromResumen(): void {
    this.syncSelectionsFromPersonalizacion();
    this.syncStateWithView();
  }

  private syncSelectionsFromPersonalizacion(): void {
    this.personalizacionCategorias.forEach((categoria) => {
      const key = String(this.getCategoryId(categoria));
      this.selectedIdsByView[key] = this.toNumericId(categoria.selected);
      this.selectedNamesByView[key] = null;
    });
    this.personalizacionSeleccionada.forEach((seleccion) => {
      const key = String(seleccion.variacion || '');
      if (!key) {
        return;
      }
      this.selectedIdsByView[key] = this.toNumericId(seleccion.configuracion);
      this.selectedNamesByView[key] = seleccion.nombre || null;
    });
  }

  private allPersonalizacionSelected(): boolean {
    if (!this.personalizacionCategorias.length) {
      return true;
    }
    return this.personalizacionCategorias.every((categoria) => {
      const key = String(this.getCategoryId(categoria));
      return this.selectedIdsByView[key] != null;
    });
  }

  private extractSelectionId(collection: any[], keys: string[], key: PersonalizacionKey): number | null {
    if (!collection?.length) {
      return null;
    }
    const candidate = collection[0];
    if (!candidate) {
      return null;
    }
    for (const key of keys) {
      const numericValue = this.toNumericId(candidate[key]);
      if (numericValue != null) {
        return numericValue;
      }
    }

    const itemByName = this.findCatalogItemByName(candidate.nombre, key);
    return this.getItemId(itemByName);
  }

  private marcarOpcionSeleccionada(key: PersonalizacionKey, id: number): void {
    this.selectedIdsByView[key] = id;
    this.selectedNamesByView[key] = this.getCatalogByKey(key).find(item => this.getItemId(item) === id)?.configuracion || null;
    if (this.getKeyFromView(this.statusView) === key) {
      this.selectedOptionId = id;
      this.updatePreviewImage(id);
    }
  }

  private findCatalogItemById(id: number | null, view: number): any {
    if (id == null) {
      return null;
    }
    return this.getCatalogByView(view).find(item => this.getItemId(item) === id);
  }

  private findCatalogItemByName(name: string | null, key: PersonalizacionKey): any {
    if (!name) {
      return null;
    }
    return this.getCatalogByKey(key).find(item => (item.configuracion || item.nombre) === name);
  }

  private extractSelectionName(collection: any[]): string | null {
    if (!collection?.length) {
      return null;
    }
    return collection[0]?.nombre || null;
  }

  private getItemId(item: any): number | null {
    if (!item) {
      return null;
    }
    return this.toNumericId(item.id ?? item.ID ?? item.configuracion);
  }

  private toNumericId(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  private getCategoryId(categoria: any): number | null {
    return this.toNumericId(categoria?.id ?? categoria?.variacion);
  }

  private getOptionIdFromInput(value: string): number | null {
    const parsed = Number(String(value || '').split(' - ')[0]);
    if (!Number.isNaN(parsed) && parsed > 0) {
      return parsed;
    }
    const match = this.currentCatalog.find((option) => {
      const nombre = (option.configuracion || option.nombre || '').toLowerCase();
      return nombre === String(value || '').toLowerCase();
    });
    return this.getItemId(match);
  }

}
